import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import {
  TOGGLE_SIDEBAR,
  PORTAL_SHOW,
  PORTAL_HIDE,
  SMART_SET,
  SMART_UPDATE,
} from "../constants";

import headerMenu from "../../config/headerMenu.json";

const initialState = {
  sidebar: false,
  portal: null,
  smartMenu: null,
  headerMenu,
};

const persistConfig = {
  key: "ui",
  storage,
  blacklist: ["sidebar", "portal"],
};

function uiReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return { ...state, sidebar: !state.sidebar };

    case PORTAL_SHOW:
      return { ...state, portal: action.result };

    case PORTAL_HIDE:
      return { ...state, portal: null };

    case SMART_SET:
      return { ...state, smartMenu: action.smartMenu };

    case SMART_UPDATE:
      return {
        ...state,
        smartMenu: {
          ...state.smartMenu,
          ...action.smartMenu,
        },
      };
    
    default:
      return state;
  }
}

export default persistReducer(persistConfig, uiReducer);